export const MenuState = {
  main: 'main',
  language: 'language',
  theme: 'theme',
  availabilityGroups: 'availabilityGroups',
} as const

export type MenuStateType = (typeof MenuState)[keyof typeof MenuState]
